export default "__VITE_ASSET__DISo$Kwd__"